//
//
//
//
//
//
//
//
//
//

import i18n from "@/utils/i18n";
export default {
  name: "labelIconPosition-editor",
  mixins: [i18n],
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object
  },
  data: function data() {
    return {
      labelIconPosition: [{
        label: 'front',
        value: 'front'
      }, {
        label: 'rear',
        value: 'rear'
      }]
    };
  }
};